import {forwardRef} from "react";
import {USER_DATE_FORMAT} from "shared/constants/date";
import type {AppDatePickerComponent, AppDatePickerProps} from "../Base/DatePickerBase.types";
import {AppDatePickerBase} from "../Base/DatePickerBase";

export const AppDatePicker = forwardRef<AppDatePickerComponent, AppDatePickerProps>(
  (props, ref) => {
    return <AppDatePickerBase format={USER_DATE_FORMAT} {...props} picker="date" ref={ref} showToday={false}/>;
  });
